export default function Dynamictext({ title, secondDesc }) {
  return (
    <>
      <section className="dynamictext-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="dynamicmain-text">
                <div
                  dangerouslySetInnerHTML={{
                    __html: secondDesc,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
